<div class="fx-column" *ngIf="trademark && mode === 'CONSULTATION'">
  <div class="fx-row fx-wrap align-items-stretch justify-content-start fx-flex-100">
    <div class="fx-flex-70 pr-8 pb-8 border-box">
      <mat-card class="p-0">
        <div class="p-16">
          <span class="text bold">{{'TRADEMARK.INFORMATION' | translate}}</span>
        </div>
        <mat-divider></mat-divider>
        <div
          class="fx-flex-100 ph-16 pv-8 border-box main-bg fx-row align-items-center justify-content-between clickable"
          >
          <div class="fx-column">
            <span class="small white">{{'ENTITIES.TRADEMARK_FAMILY' | translate}}</span>
            <span class="text white bold" *ngIf="getFamily().exist">{{getFamily().label}}</span>
            <span class="text white bold" *ngIf="!getFamily().exist">{{'TRADEMARK.NO_FAMILY' | translate}}</span>
          </div>
          <button [cdkMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon class="white" fontSet="material-icons-outlined">more_vert</mat-icon>
          </button>
          <ng-template #menu>
            <mat-card class="menu-container p-0 elevation" cdkMenu>
              <div class="fx-column">
                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                  (click)="toFamily()" cdkMenuItem *ngIf="getFamily().exist">
                  <span class="text">{{'TRADEMARK.SEE_FAMILY' | translate}}</span>
                </div>
                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                  (click)="actionFamily()" cdkMenuItem aclBasedElement resource="TRADEMARK" [scopes]="['U']">
                  <span class="text">{{(getFamily().exist ? 'TRADEMARK.UPDATE_FAMILY' : 'TRADEMARK.LINK_FAMILY') |
                    translate}}</span>
                </div>
              </div>
            </mat-card>
          </ng-template>
        </div>
        <div class="p-8 fx-row fx-wrap align-items-start justify-content-start">
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.REPRODUCTION_STANDARD_CHARACTERS' | translate}}</span>
            <span class="text" *ngIf="trademark.name">{{trademark.name}}</span>
            <span class="text"
              *ngIf="!trademark.name && trademark.type && !['Figurative','Colour'].includes(trademark.type)">-</span>
            <span class="text" *ngIf="!trademark.name && trademark.type === 'Figurative'">({{'TRADEMARK.FIGURATIVE' |
              translate}})</span>
            <span class="text" *ngIf="!trademark.name && trademark.type === 'Colour'">({{'TRADEMARK.COLOUR' |
              translate}})</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.APPLICATION_NUMBER' | translate}}</span>
            <span class="text">{{trademark.applicationNumber || '-'}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.CLIENT_REFERENCE' | translate}}</span>
            <span class="text">{{ trademark.clientReference || '-' }}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.REGISTRATION_NUMBER' | translate}}</span>
            <span class="text">{{trademark.registrationNumber || '-'}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.DESIGNATION_COUNTRY' | translate}}</span>
            <span class="text">{{getCountry()}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.KIND' | translate}}</span>
            <span class="text">{{trademark.kind|| '-'}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.TYPE' | translate}}</span>
            <span class="text">{{trademark.type || '-'}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.APPLICATION_DATE' | translate}}</span>
            <span class="text">{{formatDate(trademark.applicationDate)}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.PUBLICATION_DATE' | translate}}</span>
            <span class="text">{{formatDate(trademark.publicationDate)}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.REGISTRATION_DATE' | translate}}</span>
            <span class="text">{{formatDate(trademark.registrationDate)}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.EXPIRATION_DATE' | translate}}</span>
            <span class="text">{{formatDate(trademark.expirationDate)}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'TRADEMARK.DESCRIPTION' | translate}}</span>
            <span class="text">{{trademark.description || '-'}}</span>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <span class="small light">{{'SYNC.LAST_SYNCHRONIZATION' | translate}}</span>
            @if (trademark.synchronization) {
              <div class="fx-row align-items-center justify-content-start">
                <mat-icon class="mr-5" inline [class.green]="isSynchronizationSuccess()"
                  [class.orange]="!isSynchronizationSuccess()" fontSet="material-icons-outlined">{{
                  isSynchronizationSuccess() ? 'check_circle' : 'error' }}</mat-icon>
                <span class="text">{{formatSynchronizationDate(trademark.synchronization.date)}}</span>
              </div>
              @if (!isSynchronizationSuccess()) {
                <span class="small orange">{{synchronizationFailureKey() | translate}}</span>
                @if (trademark.synchronization.lastSuccessDate) {
                  <span class="small light">{{'SYNC.LAST_SUCCESS' | translate:{ date:
                    formatSynchronizationDate(trademark.synchronization.lastSuccessDate) } }}</span>
                }
              }
            } @else {
              <span class="text light">{{'SYNC.NEVER_SYNCHRONIZED' | translate}}</span>
            }
          </div>
        </div>
      </mat-card>
    </div>
    <div class="fx-flex-30 pl-8 pb-8 border-box">
      <div class="fx-column h-100">
        <!-- Trademark reproduction -->
        <mat-card class="p-0 mb-8 fx-flex">
          <div class="fx-column h-100">
            <div class="p-16">
              <span class="text bold">{{'TRADEMARK.REPRODUCTION_SHORT' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="fx-flex office h-100" *ngIf="trademark.reproductionURI"
              [style.background-image]="'url(' + trademark.reproductionURI + ')'">
            </div>
            <div class="p-16 fx-column align-items-center justify-content-center fx-flex border-box"
              *ngIf="!trademark.reproductionURI">
              <span class="small light">{{'TRADEMARK.NO_REPRODUCTION' | translate}}</span>
            </div>
          </div>
        </mat-card>
        <mat-card class="p-0 mt-8 fx-flex">
          <div class="fx-column h-100">
            <div class="p-16">
              <span class="text bold">{{'TRADEMARK.OFFICE' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="fx-flex office"
              matTooltip="{{trademark.propertyOffice.name}} ({{trademark.propertyOffice.code}})"
              *ngIf="trademark.propertyOffice && trademark.propertyOffice.logo"
              [style.background-image]="'url('+trademark.propertyOffice.logo+')'">
            </div>
            <div class="fx-flex office fx-column align-items-center justify-content-center"
              matTooltip="{{trademark.propertyOffice.name}} ({{trademark.propertyOffice.code}})"
              *ngIf="trademark.propertyOffice && !trademark.propertyOffice.logo">
              <span class="dark text">{{trademark.propertyOffice.name}} ({{trademark.propertyOffice.code}})</span>
            </div>
            <div class="fx-column align-items-center justify-content-center fx-flex border-box p-16"
              *ngIf="!trademark.propertyOffice">
              <span class="small light">{{'TRADEMARK.NO_OFFICE' |
                translate}}</span>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="fx-flex-100 pb-8 pt-8 border-box">
    <mat-card class="p-0">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.CLASSIFICATION' | translate}}</span>
        <div class="fx-row fx-wrap align-items-center justify-content-start">
          <mat-icon class="light mr-5" inset inline fontSet="material-icons-outlined">info</mat-icon>
          <span class="small light">{{'TRADEMARK.PS_DISPLAYED_ORIGINAL_LANG' | translate}}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16">
        <!-- <div class="fx-row fx-wrap align-items-center justify-content-start">
          <mat-checkbox color="primary" (change)="toggleApplicationLanguage()"
            [checked]="isDisplayedInApplicationLanguage()">
            <span class="text">{{'TRADEMARK.PS_DISPLAY_ORIGINAL_LANG' | translate}}</span>
          </mat-checkbox>
        </div> -->

        <mat-expansion-panel *ngFor="let niceClass of trademark.niceClassification" class="mb-10">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="fx-row align-items-center justify-content-between fx-flex-100">
                <div class="fx-row align-items-center justify-content-start fx-flex">
                  <span class="text bold">{{'NICE_CLASSES.CLASS_NUMBER' |
                    translate}}{{niceClass.classNumber}}</span>
                  <mat-icon class="main ml-5" fontSet="material-icons-outlined"
                    [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="'NICE_CLASSES.'+niceClass.classNumber | translate">info</mat-icon>
                </div>
                <div class="chip main fx-row align-items-center justify-content-start mr-16">
                  {{getProductsServices(niceClass.classNumber).length}}
                  {{'ENTITIES.PRODUCTS_SERVICES' |
                  translate}}
                </div>
              </div>

            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="p-16 fx-row fx-wrap align-items-center justify-content-start">
            <div class="chip basic mr-8 mb-8 fx-row align-items-center justify-content-start"
              *ngFor="let ps of getProductsServices(niceClass.classNumber)">
              {{ps.label}}
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-card>
  </div>
</div>
<div class="fx-column" *ngIf="trademark && mode === 'EDITION'">
  <div class="fx-row fx-wrap align-items-stretch justify-content-start fx-flex-100">
    <div class="fx-flex-70 pr-8 pb-8 border-box">
      <mat-card class="p-0">
        <div class="p-16">
          <span class="text bold">{{'TRADEMARK.INFORMATION' | translate}}</span>
        </div>
        <mat-divider></mat-divider>
        <div
          class="fx-flex-100 ph-16 pv-8 border-box main-bg fx-row align-items-center justify-content-between clickable"
          *ngIf="!creation"
          >
          <div class="fx-column"
          >
            <span class="small white">{{'ENTITIES.TRADEMARK_FAMILY' | translate}}</span>
            <span class="text white bold" *ngIf="getFamily().exist">{{getFamily().label}}</span>
            <span class="text white bold" *ngIf="!getFamily().exist">{{'TRADEMARK.NO_FAMILY' | translate}}</span>
          </div>
          <button [cdkMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon class="white" fontSet="material-icons-outlined">more_vert</mat-icon>
          </button>
          <ng-template #menu>
            <mat-card class="menu-container p-0 elevation" cdkMenu>
              <div class="fx-column">
                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                  (click)="toFamily()" cdkMenuItem *ngIf="getFamily().exist">
                  <span class="text">{{'TRADEMARK.SEE_FAMILY' | translate}}</span>
                </div>
                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                  (click)="actionFamily()" cdkMenuItem aclBasedElement resource="TRADEMARK" [scopes]="['U']">
                  <span class="text">{{(getFamily().exist ? 'TRADEMARK.UPDATE_FAMILY' : 'TRADEMARK.LINK_FAMILY') |
                    translate}}</span>
                </div>
              </div>
            </mat-card>
          </ng-template>
        </div>
        <div class="p-8 fx-row fx-wrap align-items-start justify-content-start">
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input label="{{'TRADEMARK.REPRODUCTION_STANDARD_CHARACTERS' | translate}}"
              placeholder="{{'TRADEMARK.REPRODUCTION_STANDARD_CHARACTERS' | translate}}" type="text"
              [(value)]="trademark.name"></app-input>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-select
              initial="none" label="{{'TRADEMARK.STATUS' | translate}}" [options]="trademarkStatuses"
              [multiple]="false" (change)="onTrademarkStatusChange($event)" [emitOnInit]="false" [value]="trademark.status"
              [labelOutside]="true"></app-select>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input label="{{'TRADEMARK.APPLICATION_NUMBER' | translate}}"
              placeholder="{{'TRADEMARK.APPLICATION_NUMBER' | translate}}" type="text"
              [(value)]="trademark.applicationNumber" [error]="validate('applicationNumber')"></app-input>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input
              label="{{'TRADEMARK.CLIENT_REFERENCE' | translate}}"
              placeholder="{{'TRADEMARK.CLIENT_REFERENCE' | translate}}"
              type="text" [(value)]="trademark.clientReference"></app-input>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input
              label="{{(creation ? 'TRADEMARK.REGISTRATION_NUMBER_CREATION' : 'TRADEMARK.REGISTRATION_NUMBER') | translate}}"
              placeholder="{{(creation ? 'TRADEMARK.REGISTRATION_NUMBER_CREATION' : 'TRADEMARK.REGISTRATION_NUMBER') | translate}}"
              type="text" [(value)]="trademark.registrationNumber" [error]="validate('registrationNumber')"></app-input>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-territory-select label="{{'TRADEMARK.DESIGNATION_COUNTRY' | translate}}" [multiple]="false"
              [search]="true" initial="none" [labelOutside]="true" [error]="validate('countryOfDesignation')"
              [(value)]="trademark.countryOfDesignation"></app-territory-select>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input label="{{'TRADEMARK.KIND' | translate}}" placeholder="{{'TRADEMARK.KIND' | translate}}"
              type="text" [(value)]="trademark.kind"></app-input>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-select initial="none" label="{{'TRADEMARK.TYPE' | translate}}" [options]="trademarkTypes"
              [multiple]="false" (change)="onTrademarkTypeChange($event)" [emitOnInit]="false" [value]="trademark.type"
              [labelOutside]="true" [error]="validate('type')"></app-select>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-datepicker label="{{'TRADEMARK.APPLICATION_DATE' | translate}}"
              placeholder="{{'TRADEMARK.APPLICATION_DATE' | translate}}"
              [(value)]="trademark.applicationDate" [error]="validate('applicationDate')"></app-datepicker>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-datepicker label="{{'TRADEMARK.PUBLICATION_DATE' | translate}}"
              placeholder="{{'TRADEMARK.PUBLICATION_DATE' | translate}}"
              [(value)]="trademark.publicationDate"></app-datepicker>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-datepicker label="{{'TRADEMARK.REGISTRATION_DATE' | translate}}"
              placeholder="{{'TRADEMARK.REGISTRATION_DATE' | translate}}"
              [(value)]="trademark.registrationDate" [error]="validate('registrationDate')"></app-datepicker>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-datepicker label="{{'TRADEMARK.EXPIRATION_DATE' | translate}}"
              placeholder="{{'TRADEMARK.EXPIRATION_DATE' | translate}}"
              [(value)]="trademark.expirationDate"></app-datepicker>
          </div>
          <div class="fx-flex-50 p-8 border-box fx-column">
            <app-input label="{{'TRADEMARK.DESCRIPTION' | translate}}"
              placeholder="{{'TRADEMARK.DESCRIPTION' | translate}}" type="text"
              [(value)]="trademark.description"></app-input>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="fx-flex-30 pl-8 pb-8 border-box fx-column">
      <mat-card class="p-0">
        <div class="fx-row fx-wrap align-items-start justify-content-start">
          <div class="p-16 fx-flex-100">
            <span class="text bold">{{'TRADEMARK.REPRODUCTION_SHORT' | translate}}</span>
          </div>
          <mat-divider class=" fx-flex-100"></mat-divider>
          <div class="m-16 fx-row align-items-center justify-content-center fx-flex-100">
            <app-upload-picture [src]="trademark.reproductionURI" (pictureChange)="onReproductionChange($event)"
              class="fx-flex-100"></app-upload-picture>
          </div>
        </div>
      </mat-card>
      <mat-card class="p-0 fx-flex mt-16">
        <div class="fx-column h-100">
          <div class="p-16">
            <span class="text bold">{{'TRADEMARK.OFFICE' | translate}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="p-16 fx-row align-items-center justify-content-center fx-flex-100">
            <app-property-office-select label="{{'ENTITIES.PROPERTY_OFFICE' | translate}}" class="fx-flex-100"
              [search]="true" (change)="onPropertyOfficeChange($event)" [(value)]="propertyOffice"
              [error]="validate('propertyOffice')"></app-property-office-select>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div class="fx-flex-100 pb-8 pt-8 border-box">
    <mat-card class="p-0">
      <div class="p-16 fx-row align-items-center justify-content-between">
        <span class="text bold">{{'TRADEMARK.CLASSIFICATION' | translate}}</span>
        <span class="small red ml-5"
          *ngIf="validate('niceClassification').value">{{'TRADEMARK.NICE_CLASSIFICATION_REQUIRED' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16">
        <div class="fx-row align-items-center justify-content-start mv-8"
          *ngFor="let niceClass of trademark.niceClassification">
          <app-nice-select label="{{'TRADEMARK_DECLARE.ADD_CLASS' | translate}}" [labelOutside]="false"
            [multiple]="false" [search]="true" class="mr-10 nice-selector" initial="none"
            [(value)]="niceClass.classNumber" [disabledValues]="disabledNiceClasses"
            [emitOnInit]="false"></app-nice-select>
          <app-input placeholder="{{'TRADEMARK_DECLARE.CLASS_DETAILS' | translate}}" type="text"
            [(value)]="niceClass.details" class="fx-flex"></app-input>
          <button mat-icon-button class="ml-10" (click)="removeClass(niceClass)">
            <mat-icon fontSet="material-icons-outlined" class="red">highlight_off</mat-icon>
          </button>
        </div>
        <mat-divider class="mv-8"
          *ngIf="trademark.niceClassification && trademark.niceClassification.length > 0"></mat-divider>
        <div class="fx-row align-items-center justify-content-start mt-8">
          <app-nice-select label="{{'TRADEMARK_DECLARE.ADD_CLASS' | translate}}" [labelOutside]="false"
            [multiple]="false" [search]="true" class="mr-10 nice-selector" [(value)]="newClass.classNumber"
            [disabledValues]="disabledNiceClasses" [emitOnInit]="false"></app-nice-select>
          <app-input placeholder="{{'TRADEMARK_DECLARE.CLASS_DETAILS' | translate}}" type="text"
            [(value)]="newClass.details" class="fx-flex"></app-input>
          <button class="main-button ml-10" (click)="addClass()" [disabled]="!newClass.classNumber"
            [class.disabled]="!newClass.classNumber">
            {{'TRADEMARK_DECLARE.ADD_CLASS' | translate}}
          </button>
        </div>
      </div>
    </mat-card>
  </div>
</div>
<div *ngIf="trademark && mode === 'COMPARISON'">
  <mat-card class="p-0">
    <div class="p-16">
      <div class="fx-row align-items-center justify-content-start" *ngIf="changesCount > 0">
        <mat-icon fontSet="material-icons-outlined" class="main mr-10">info</mat-icon>
        <span class="text">{{'TRADEMARK.COMPARISON_DIFFERENCES' | translate}}</span>
      </div>
      <div class="fx-row align-items-center justify-content-start" *ngIf="changesCount === 0">
        <mat-icon fontSet="material-icons-outlined" class="green mr-10">check_circle</mat-icon>
        <span class="text">{{'TRADEMARK.COMPARISON_NO_DIFFERENCE' | translate}}</span>
      </div>
    </div>
    <mat-divider *ngIf="differences.length > 0"></mat-divider>
    <div class="fx-row fx-wrap align-items-start justify-content-center p-16" *ngIf="differences.length > 0">
      <div *ngFor="let difference of differences; let last = last;" class="fx-flex-100 fx-row fx-wrap">
        <div class="fx-row align-items-start justify-content-between fx-flex-100">
          <div class="fx-flex-20 fx-column align-items-start justify-content-start">
            <span class="text bold" [class.orange]="difference.warning">{{difference.label | translate}}</span>
            @if (difference.warning) {
              <div class="fx-row align-items-center justify-content-start mt-5">
                <mat-icon class="orange mr-5" inline fontSet="material-icons-outlined">warning</mat-icon>
                <span class="small orange">{{'TRADEMARK.COMPARISON_APPLICATION_DATE_CHANGE' | translate}}</span>
              </div>
            }
          </div>
          @if (difference.kind === 'classes' && difference.classes) {
            <div class="fx-flex-70 fx-column align-items-start justify-content-start">
              @for (niceClass of difference.classes; track niceClass.classNumber) {
                <div class="fx-row align-items-start justify-content-between fx-flex-100 mb-10">
                  <div class="fx-flex-50 fx-column align-items-start justify-content-start pr-8 border-box">
                    <span class="small light">{{'TRADEMARK.COMPARISON_OLD_VALUE' | translate}}</span>
                    @if (niceClass.change === 'ADDED') {
                      <span class="text">-</span>
                    } @else {
                      <ng-container *ngTemplateOutlet="niceClassValue; context: { $implicit: niceClass.classNumber, details: niceClass.old }"></ng-container>
                    }
                  </div>
                  <div class="fx-flex-50 fx-column align-items-start justify-content-start pl-8 border-box">
                    <div class="fx-row align-items-center justify-content-start">
                      <span class="small light mr-5">{{'TRADEMARK.COMPARISON_NEW_VALUE' | translate}}</span>
                      @switch (niceClass.change) {
                        @case ('ADDED') { <span class="chip small green">{{'TRADEMARK.COMPARISON_CLASS_ADDED' | translate}}</span> }
                        @case ('REMOVED') { <span class="chip small red">{{'TRADEMARK.COMPARISON_CLASS_REMOVED' | translate}}</span> }
                        @case ('WORDING') { <span class="chip small orange">{{'TRADEMARK.COMPARISON_CLASS_WORDING' | translate}}</span> }
                      }
                    </div>
                    @switch (niceClass.change) {
                      @case ('REMOVED') { <span class="text">-</span> }
                      @case ('WORDING_KEPT') {
                        <span class="text light">{{'TRADEMARK.COMPARISON_WORDING_KEPT' | translate}}</span>
                      }
                      @default {
                        <ng-container *ngTemplateOutlet="niceClassValue; context: { $implicit: niceClass.classNumber, details: niceClass.new }"></ng-container>
                      }
                    }
                  </div>
                </div>
              }
              @if (difference.unchangedClasses && difference.unchangedClasses.length > 0) {
                <span class="small light">{{'TRADEMARK.COMPARISON_UNCHANGED_CLASSES' | translate:{ classes: difference.unchangedClasses.join(', ') } }}</span>
              }
            </div>
          } @else {
            <div class="fx-flex-35 fx-column align-items-start justify-content-start">
              <span class="small light">{{'TRADEMARK.COMPARISON_OLD_VALUE' | translate}}</span>
              <ng-container *ngTemplateOutlet="comparisonValue; context: { $implicit: difference.old, kind: difference.kind }"></ng-container>
            </div>
            <div class="fx-flex-35 fx-column align-items-start justify-content-start">
              <span class="small light">{{'TRADEMARK.COMPARISON_NEW_VALUE' | translate}}</span>
              @if (difference.kept) {
                <span class="text light">{{(difference.kind === 'image' && refreshed?.blankImage ? 'SYNC.CANDIDATES.BLANK_IMAGE' : 'TRADEMARK.COMPARISON_NOT_PROVIDED') | translate}}</span>
              } @else {
                <ng-container *ngTemplateOutlet="comparisonValue; context: { $implicit: difference.new, kind: difference.kind }"></ng-container>
              }
            </div>
          }
        </div>
        <mat-divider class="mv-16 fx-flex-100" *ngIf="!last"></mat-divider>
      </div>
    </div>
  </mat-card>
</div>
<ng-template #comparisonValue let-value let-kind="kind">
  @switch (kind) {
    @case ('date') {
      <span class="text">{{formatDate(value)}}</span>
    }
    @case ('status') {
      @if (value) {
        <app-trademark-status [status]="value"></app-trademark-status>
      } @else {
        <span class="text">-</span>
      }
    }
    @case ('office') {
      <span class="text">{{value ? (value.name || value.code) : '-'}}</span>
    }
    @case ('classes') {
      @for (niceClass of value; track $index) {
        <div class="fx-column align-items-start justify-content-start mb-10">
          <ng-container *ngTemplateOutlet="niceClassValue; context: { $implicit: niceClass.classNumber, details: niceClass.details }"></ng-container>
        </div>
      } @empty {
        <span class="text">-</span>
      }
    }
    @case ('image') {
      @if (value) {
        <img [src]="value" class="comparison-reproduction" alt="" />
      } @else {
        <span class="text">-</span>
      }
    }
    @default {
      <span class="text">{{value || '-'}}</span>
    }
  }
</ng-template>
<ng-template #niceClassValue let-classNumber let-details="details">
  <div class="chip main fx-row align-items-center justify-content-start mb-5">
    <span><b>{{'NICE_CLASSES.CLASS_NUMBER' | translate}}{{classNumber}}</b>&nbsp;-&nbsp;{{'NICE_CLASSES.'+classNumber | translate}}</span>
  </div>
  <span class="text">{{details || '-'}}</span>
</ng-template>
